export default __webpack_public_path__ + "adbe03981e76e507186fb767fd14f03d.png";